// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--1Uhh5","minimal":"Header-module--minimal--IKdz_ Header-module--header--1Uhh5"};